import { type LoaderFunctionArgs } from '@remix-run/cloudflare'

import { Form, useSearchParams } from '@remix-run/react'
import { getUserSession } from '@services/session.server.ts'

export async function loader({ request, context }: LoaderFunctionArgs) {
  await getUserSession({ context, request })

  return null
}

export default function LoginView() {
  const [sParams] = useSearchParams()
  const redirectTo = sParams.get('redirectTo')
  return (
    <div className={'w-full flex-shrink flex-grow p-8'}>
      <main className="mx-auto w-full max-w-md p-6">
        <div className="mt-7 rounded-xl border border-base-content shadow-sm">
          <div className="p-4 sm:p-7">
            <div className="text-center">
              <h1 className="block text-2xl font-bold">Sign in</h1>
            </div>

            <div className="mt-5">
              <div className="flex items-center py-3 text-xs uppercase before:mr-6 before:flex-[1_1_0%] before:border-t before:border-base-content after:ml-6 after:flex-[1_1_0%] after:border-t after:border-base-content">
                with
              </div>
              <Form action={`/auth/ms${redirectTo == null ? '' : '?redirectTo=' + redirectTo}`}>
                <div className="grid gap-y-4">
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center gap-2 rounded-md border border-transparent bg-blue-500 px-4 py-3 text-sm font-semibold text-white transition-all hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    <svg
                      id="bdb56329-4717-4410-aa13-4505ecaa4e46"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3.5 w-3.5"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <defs>
                        <linearGradient
                          id="ba2610c3-a45a-4e7e-a0c0-285cfd7e005d"
                          x1="13.25"
                          y1="13.02"
                          x2="8.62"
                          y2="4.25"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stopColor="#1988d9" />
                          <stop offset="0.9" stopColor="#54aef0" />
                        </linearGradient>
                        <linearGradient
                          id="bd8f618b-4f2f-4cb7-aff0-2fd2d211326d"
                          x1="11.26"
                          y1="10.47"
                          x2="14.46"
                          y2="15.99"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0.1" stopColor="#54aef0" />
                          <stop offset="0.29" stopColor="#4fabee" />
                          <stop offset="0.51" stopColor="#41a2e9" />
                          <stop offset="0.74" stopColor="#2a93e0" />
                          <stop offset="0.88" stopColor="#1988d9" />
                        </linearGradient>
                      </defs>
                      <title>Icon-identity-221</title>
                      <polygon
                        points="1.01 10.19 8.93 15.33 16.99 10.17 18 11.35 8.93 17.19 0 11.35 1.01 10.19"
                        fill="#50e6ff"
                      />
                      <polygon
                        points="1.61 9.53 8.93 0.81 16.4 9.54 8.93 14.26 1.61 9.53"
                        fill="#fff"
                      />
                      <polygon points="8.93 0.81 8.93 14.26 1.61 9.53 8.93 0.81" fill="#50e6ff" />
                      <polygon
                        points="8.93 0.81 8.93 14.26 16.4 9.54 8.93 0.81"
                        fill="url(#ba2610c3-a45a-4e7e-a0c0-285cfd7e005d)"
                      />
                      <polygon points="8.93 7.76 16.4 9.54 8.93 14.26 8.93 7.76" fill="#53b1e0" />
                      <polygon points="8.93 14.26 1.61 9.53 8.93 7.76 8.93 14.26" fill="#9cebff" />
                      <polygon
                        points="8.93 17.19 18 11.35 16.99 10.17 8.93 15.33 8.93 17.19"
                        fill="url(#bd8f618b-4f2f-4cb7-aff0-2fd2d211326d)"
                      />
                    </svg>
                    Azure AD
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
